import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { UploadFilesComponent } from '../../components/common/upload/upload.component';
import { UploadFilesModule } from '../../components/common/upload/upload.module';
import { DocumentFileModule } from '../documentFile/documentFile.module';
import { basicDocumentComponent } from './basicDocument.component';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { TranslateModule } from '@ngx-translate/core';
import { templateModalComponent } from './basicDocumentModal.component';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { DossierHeaderModule } from '../../dossiers/components/dossierHeader.module';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { formElementComponent } from '../../components/forms/formElement.component';
import { DirectivesModule } from '../../directives/directives.module';
import { RejectionPanelComponent } from '../rejectionPanel/rejectionPanel.component';
import { RejectionPanelModule } from '../rejectionPanel/rejectionPanel.module';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { ConfirmationService } from 'primeng-lts/api';
import { CalendarModule } from 'primeng-lts/calendar';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { ListboxModule } from 'primeng-lts/listbox';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TreeModule } from 'primeng-lts/tree';
import { DropdownModule } from 'primeng-lts/dropdown';

@NgModule({
  declarations: [basicDocumentComponent, templateModalComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    RouterModule,
    UploadFilesModule,
    DocumentFileModule,
    PanelModule,
    WaitLoadingModule,
    CalendarModule,
    DropdownModule,
    ConfirmDialogModule,
    CheckboxModule,
    ScrollPanelModule,
    SubHeaderModule,
    DossierHeaderModule,
    FormPlycaModule,
    OverlayPanelModule,
    ListboxModule,
    DirectivesModule,
    TreeModule,
    RejectionPanelModule
  ],
  providers: [ConfirmationService, PlycaErrorHandler],
  entryComponents: [
    UploadFilesComponent,
    templateModalComponent,
    formElementComponent,
    RejectionPanelComponent
  ],
  exports: [basicDocumentComponent]
})
export class BasicDocumentModule { }
